<template>
  <div class="h-100">
    <v-row class="h-100">
      <layout-notifications />

      <v-col cols="12" md="6" offset-md="3" class="page-content-container">
        <h1>Wymagana jest zmiana hasła</h1>

        <p>
          W związku z ustaleniem nowego hasła przez opreratora, w celu zachowania bezpieczeństwa, należy zmienić hasło.
        </p>

        <change-password-form @password-changed="redirectToHome" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ChangePasswordForm from '@/components/forms/ChangePasswordForm';
import { clearIdbStore } from '@/utils/idbKeyval';

// @vuese
// Widok wymuszający zmianę hasła
// @group Views
export default {
  components: { ChangePasswordForm },
  methods: {
    // @vuese
    // Przekierowuje na stronę główną
    redirectToHome() {
      clearIdbStore().then(() => this.$router.replace({ name: 'home' }));
    }
  }
};
</script>
